export default __webpack_public_path__ + "images/assets/3cc0bd6c190985e23d26c7bf4e465694.svg";